/*
 *
 *  actions
 *
 */

import {
  LOAD_RECORDS_VALID_CACHE,
  LOAD_RECORDS_META_DATA,
  LOAD_RECORDS_META_DATA_SUCCESS,
  LOAD_RECORDS_META_DATA_ERROR,
  LOAD_TICKET_QUERY,
  LOAD_TICKET_QUERY_SUCCESS,
  LOAD_TICKET_QUERY_ERROR,
  ADD_TICKET_QUERY,
  ADD_TICKET_QUERY_SUCCESS,
  ADD_TICKET_QUERY_ERROR,
  LOAD_PRIORITY_RECORDS_META_DATA,
  LOAD_PRIORITY_RECORDS_META_DATA_SUCCESS,
  LOAD_PRIORITY_RECORDS_META_DATA_ERROR,
  ADD_LABEL,
  ADD_LABEL_SUCCESS,
  ADD_LABEL_ERROR,
  DELETE_TICKET_QUERY,
  DELETE_TICKET_QUERY_SUCCESS,
  DELETE_TICKET_QUERY_ERROR,
  LOAD_SUBLABEL_META_DATA,
  LOAD_SUBLABEL_META_DATA_SUCCESS,
  LOAD_SUBLABEL_META_DATA_ERROR,
  ADD_SUB_LABEL,
  ADD_SUB_LABEL_SUCCESS,
  ADD_SUB_LABEL_ERROR,
  LOAD_EMPLOYEE_LABELS,
  LOAD_EMPLOYEE_LABELS_SUCCESS,
  LOAD_EMPLOYEE_LABELS_ERROR,
  LOAD_EMPLOYEE_SUB_LABELS,
  LOAD_EMPLOYEE_SUB_LABELS_SUCCESS,
  LOAD_EMPLOYEE_SUB_LABELS_ERROR,
  LOAD_TICKET_NOTIFICATIONS,
  LOAD_TICKET_NOTIFICATIONS_SUCCESS,
  LOAD_TICKET_NOTIFICATIONS_ERROR,
} from "./constants"

export function loadRecordsCacheHit() {
  return {
    type: LOAD_RECORDS_VALID_CACHE,
  }
}

export function loadRecordsMetaData() {
  return {
    type: LOAD_RECORDS_META_DATA,
  }
}

/**
 *
 * @param {object} recordsMetaData
 * @returns
 */
export function loadRecordsMetaDataSuccess(recordsMetaData) {
  return {
    type: LOAD_RECORDS_META_DATA_SUCCESS,
    recordsMetaData,
  }
}

/**
 *
 * @param {string} error
 * @returns
 */
export function loadRecordsMetaDataError(error) {
  return {
    type: LOAD_RECORDS_META_DATA_ERROR,
    error,
  }
}
export function loadPriorityRecordsMetaData() {
  return {
    type: LOAD_PRIORITY_RECORDS_META_DATA,
  }
}

/**
 *
 * @param {object} recordsMetaData
 * @returns
 */
export function loadPriorityRecordsMetaDataSuccess(priorityMetaData) {
  return {
    type: LOAD_PRIORITY_RECORDS_META_DATA_SUCCESS,
    priorityMetaData,
  }
}

/**
 *
 * @param {string} error
 * @returns
 */
export function loadPriorityRecordsMetaDataError(error) {
  return {
    type: LOAD_PRIORITY_RECORDS_META_DATA_ERROR,
    error,
  }
}
//Load sub label
export function loadSubLabelDetails(record) {
  // console.log(record, "record")
  return {
    type: LOAD_SUBLABEL_META_DATA,
    record,
  }
}

/**
 *
 * @param {object} recordsMetaData
 * @returns
 */
export function loadSubLabelDetailsSuccess(subLabel_details, success) {
  return {
    type: LOAD_SUBLABEL_META_DATA_SUCCESS,
    subLabel_details,
    success,
  }
}

/**
 *
 * @param {string} error
 * @returns
 */
export function loadSubLabelDetailsError(error) {
  return {
    type: LOAD_SUBLABEL_META_DATA_ERROR,
    error,
  }
}

//permission list
export function loadTicketQuery(searchvalue) {
  return {
    type: LOAD_TICKET_QUERY,
    searchvalue,
  }
}
export function loadTicketQuerySuccess(ticket_details) {
  return {
    type: LOAD_TICKET_QUERY_SUCCESS,
    ticket_details,
  }
}
export function loadTicketQueryError(error) {
  return {
    type: LOAD_TICKET_QUERY_ERROR,
    error,
  }
}

//permission list
export function loadTicketNotifications(notitications) {
  return {
    type: LOAD_TICKET_NOTIFICATIONS,
    notitications,
  }
}
export function loadTicketNotificationsSuccess(ticket_notifications) {
  return {
    type: LOAD_TICKET_NOTIFICATIONS_SUCCESS,
    ticket_notifications,
  }
}
export function loadTicketNotificationsError(error) {
  return {
    type: LOAD_TICKET_NOTIFICATIONS_ERROR,
    error,
  }
}

//Employee labels
export function loadEmployeeLabels(record) {
  return {
    type: LOAD_EMPLOYEE_LABELS,
    record,
  }
}
export function loadEmployeeLabelsSuccess(employee_labels) {
  return {
    type: LOAD_EMPLOYEE_LABELS_SUCCESS,
    employee_labels,
  }
}
export function loadEmployeeLabelsError(error) {
  return {
    type: LOAD_EMPLOYEE_LABELS_ERROR,
    error,
  }
}

//Employee sub labels
export function loadEmployeeSubLabels(record) {
  return {
    type: LOAD_EMPLOYEE_SUB_LABELS,
    record,
  }
}
export function loadEmployeeSubLabelsSuccess(employee_sub_labels) {
  return {
    type: LOAD_EMPLOYEE_SUB_LABELS_SUCCESS,
    employee_sub_labels,
  }
}
export function loadEmployeeSubLabelsError(error) {
  return {
    type: LOAD_EMPLOYEE_SUB_LABELS_ERROR,
    error,
  }
}

//add clearance

export function addTicketQuery(ticketQuery) {
  return {
    type: ADD_TICKET_QUERY,
    ticketQuery,
  }
}
export function addTicketQuerySuccess(ticketQuery, success) {
  return {
    type: ADD_TICKET_QUERY_SUCCESS,
    ticketQuery,
    success,
  }
}
export function addTicketQueryError(error) {
  return {
    TYPE: ADD_TICKET_QUERY_ERROR,
    error,
  }
}
//addLabel Details

export function addLabel(labelDetails) {
  return {
    type: ADD_LABEL,
    labelDetails,
  }
}
export function addLabelSuccess(labelDetails, success) {
  return {
    type: ADD_LABEL_SUCCESS,
    labelDetails,
    success,
  }
}
export function addLabelError(error) {
  return {
    TYPE: ADD_LABEL_ERROR,
    error,
  }
}
export function addSubLabel(subLabelDetails) {
  console.log(subLabelDetails, "subLabelDetails")
  return {
    type: ADD_SUB_LABEL,
    subLabelDetails,
  }
}
export function addSubLabelSuccess(subLabelDetails, success) {
  return {
    type: ADD_SUB_LABEL_SUCCESS,
    subLabelDetails,
    success,
  }
}
export function addSubLabelError(error) {
  return {
    TYPE: ADD_SUB_LABEL_ERROR,
    error,
  }
}
//deleteTicketQuery Details

export function deleteTicketQuery(deleteTicket) {
  return {
    type: DELETE_TICKET_QUERY,
    deleteTicket,
  }
}
export function deleteTicketQuerySuccess(deleteTicket, success) {
  return {
    type: DELETE_TICKET_QUERY_SUCCESS,
    deleteTicket,
    success,
  }
}
export function deleteTicketQueryError(error) {
  return {
    TYPE: DELETE_TICKET_QUERY_ERROR,
    error,
  }
}

const actions = {
  loadRecordsCacheHit,
  loadRecordsMetaData,
  loadRecordsMetaDataSuccess,
  loadRecordsMetaDataError,
  loadPriorityRecordsMetaData,
  loadPriorityRecordsMetaDataSuccess,
  loadPriorityRecordsMetaDataError,
  loadSubLabelDetails,
  loadSubLabelDetailsSuccess,
  loadSubLabelDetailsError,

  loadTicketQuery,
  loadTicketQuerySuccess,
  loadTicketQueryError,
  loadTicketNotifications,
  loadTicketNotificationsSuccess,
  loadTicketNotificationsError,

  addTicketQuery,
  addTicketQuerySuccess,
  addTicketQueryError,

  addLabel,
  addLabelSuccess,
  addLabelError,

  addSubLabel,
  addSubLabelSuccess,
  addSubLabelError,

  deleteTicketQuery,
  deleteTicketQuerySuccess,
  deleteTicketQueryError,
  loadEmployeeLabels,
  loadEmployeeLabelsSuccess,
  loadEmployeeLabelsError,
  loadEmployeeSubLabels,
  loadEmployeeSubLabelsSuccess,
  loadEmployeeSubLabelsError,
}

export default actions
